/* globals wordpress_globals */
import '../styles/theme.scss';

import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import convertDataAttributesToObject from './lib/convertDataAttributesToObejct';
import { fetchSVG, loadIcons } from './lib/SVGSprite';
import moduleDefinition, { ModuleDefinition } from './modules/definition';
import widgetDefinition, { WidgetDefinition } from '@project/scripts/modules/widgets';
import 'lite-youtube-embed';
import 'lite-vimeo-embed';
import InitWidget from '@project/scripts/widgets/InitWidget';

/**
 * Async Modules: Modules are defined in ./modules/definitions.ts
 */
const bootstrap = {
  init() {
    this.asyncSVG.init();
    this.asyncModules.init(moduleDefinition, widgetDefinition);
  },
  asyncModules: {
    init(modules: ModuleDefinition[], widgets: WidgetDefinition[]) {
      (modules ?? []).forEach(({ selector, moduleName, defaultArgs }) => {
        (document.querySelectorAll<HTMLElement>(selector) ?? []).forEach((el) => {
          const formattedArgs = convertDataAttributesToObject(el.dataset ?? {});
          const args = { ...defaultArgs, ...formattedArgs };

          return this.load(el, moduleName, args);
        });
      });

      (widgets ?? []).forEach(({ selector, moduleName }) => {
        (document.querySelectorAll<HTMLElement>(selector) ?? []).forEach((el) => {
          return new InitWidget(el, moduleName);
        });
      });
    },
    load: (el: HTMLElement, moduleName: string, args: Record<string, unknown>) => {
      try {
        return import(`./modules/${moduleName}`).then((mod) => {
          const Module = mod.default;
          return new Module(el, args);
        });
      } catch (error: unknown) {
        const err = error as Error;
        console.warn(err);
      }
      return false;
    },
  },
  asyncSVG: {
    init() {
      fetchSVG('./wp-content/themes/class/dist/sprite.svg')
        .catch((error: Error) => console.warn(`[fetchSVG] ${error}`));
    },
  },
};

document.addEventListener('DOMContentLoaded', () => {
  bootstrap.init();
});

const isMobile = () => {
  return window.innerWidth <= 768;
};

// SVG Sprite Loader
loadIcons();
